<template>

    <div>
        <v-alert elevation='5' @click='suggestion = true' dense outlined class="alert" icon="mdi-emoticon-happy-outline" >

            <template v-slot:append>

                <v-img contain class="" height="40px" width="40px" src="../../../assets/suggestion.png" alt="logo"> </v-img>

            </template>

            <v-row no-gutters class="mr-3">

                <v-col>
                    <div :class="isMobile ? 'caption' : 'body-2'"> {{ $t('dialog_suggestion.help_us') }}</div>
                </v-col>

            </v-row>

        </v-alert>

        <dialog-suggestion :dialog="suggestion" @closeDialog='suggestion = false' />

    </div>

</template>

<script>
import DialogSuggestion from './DialogSuggestion.vue'


export default {
  components: { DialogSuggestion },

    name: 'AlertSuggestion',
    data() {
        return {
            suggestion: false
        }
    },

    props: ['simple']

}
</script>

<style scoped>

.alert {

    cursor: pointer;
    margin-left: 15px !important;
    margin-right: 15px !important;


}



</style>